module.exports = __webpack_public_path__ + "img/logo1.dd51e4a7.png";